import "./cta.component.css"
import { useNavigate } from "react-router-dom"
import StrapiImageComponent from "../strapi-image/strapi-image.component"
import { daggerNavigate } from "../../utils/navigate.util"

const CtaComponent = (props) => {
  const { Heading, Copy, ButtonLabel, Media, PageLink, ExternalLink } = props
  const navigate = useNavigate()

  const handleNav = () => {
    if (ExternalLink) {
      window.location.href = ExternalLink
      return
    }

    daggerNavigate(() => navigate(`/${PageLink.data.attributes.Slug}`))
  }

  return (
    <div className="dagger-cta">
      {Media && Media.data && (
        <div className="dagger-cta-media">
          <StrapiImageComponent
            attributes={Media.data.attributes}
            sizes="(max-width: 800px) 100vw, 50vw"
          />
        </div>
      )}
      <div className="dagger-cta-copy">
        <h2>{Heading}</h2>
        <div className="dagger-cta-desc">
          {Copy}
          {ButtonLabel && (PageLink?.data || ExternalLink) && (
            <button className="dagger-outline-btn" onClick={handleNav}>
              {ButtonLabel}
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default CtaComponent
